import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  dismissBanner: {
    defaultMessage: 'Dismiss banner',
    description: 'Aria label for the dismiss button on promotional banners',
    id: '9Q3j6o',
  },
});
